import { getTestAttributes } from '@chillibean/component-library';
import { PropTypes } from 'prop-types';
import { useEffect, useRef } from 'react';

import { scrollIntoView } from '../__util__/scroll';
import Error from '../Error/Error';

export function RequestError(props) {
  const { displayNextSteps = undefined, errorMessage = undefined, errorRef = undefined, source } = props;

  const requestErrorRef = useRef(null);

  useEffect(() => {
    scrollIntoView(requestErrorRef, 'start');
  }, [source]);

  const nextStepsText = () => {
    if (!displayNextSteps) return null;

    return (
      <>
        {"We've got logs and we'll look into it, but you can be a star and help us out by logging a "}
        <a
          href="https://chillibean.atlassian.net/servicedesk/customer/portal/1/group/3/create/1"
          target="_blank"
          rel="noreferrer"
        >
          ticket
        </a>{' '}
        with the above error reference.
      </>
    );
  };

  const setErrorProps = () => {
    let errorProps = {};
    let bodyText;

    const heroHeaderTitles = [
      {
        title: 'ERROR',
        subTitle: '',
      },
    ];

    switch (source) {
      case 'JSRuntime':
      case 0:
      case 500:
        heroHeaderTitles[0].subTitle = 'ChilliPharm Error';
        errorProps = {
          heroHeaderTitles: heroHeaderTitles,
          errorReference: errorRef,
          errorMessage: 'Oh no! Something has gone wrong on our end.',
        };
        break;
      case 401:
        heroHeaderTitles[0].subTitle = 'Not Logged In';
        errorProps = {
          heroHeaderTitles: heroHeaderTitles,
          errorReference: errorRef,
          errorMessage: errorMessage,
        };
        break;
      case 403:
        heroHeaderTitles[0].subTitle = 'Permission Issue';
        errorProps = {
          heroHeaderTitles: heroHeaderTitles,
          errorReference: errorRef,
          errorMessage: errorMessage,
        };
        break;
      case 404:
        heroHeaderTitles[0].subTitle = 'Not Found';
        errorProps = {
          heroHeaderTitles: heroHeaderTitles,
          errorReference: errorRef,
          errorMessage: errorMessage,
        };

        break;
      default:
        heroHeaderTitles[0].subTitle = 'ChilliPharm Error';
        errorProps = {
          heroHeaderTitles: heroHeaderTitles,
          errorReference: errorRef,
          errorMessage: 'Oh no! Something has gone wrong on our end.',
        };
    }

    return { errorProps, bodyText };
  };

  const { errorProps, bodyText } = setErrorProps();

  return (
    <div
      ref={requestErrorRef}
      style={{ marginTop: '-50px' }}
      className="requestError"
      {...getTestAttributes('request-error')}
    >
      <Error {...errorProps}>
        {bodyText}
        {nextStepsText()}
      </Error>
    </div>
  );
}

RequestError.propTypes = {
  displayNextSteps: PropTypes.bool,
  errorMessage: PropTypes.string,
  errorRef: PropTypes.string,
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default RequestError;
